import * as React from 'react'

function IconClover({
  color,
  isFill,
  props,
}: {
  color: string
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={104}
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g filter="url(#prefix__filter3_clover)" fill={color}>
            <path d="M98.978 43.072a22.383 22.383 0 000 17.85c6.706 15.438 6.951 29.48-.812 37.244-7.76 7.763-21.801 7.514-37.239.812a22.38 22.38 0 00-17.849 0c-15.437 6.706-29.483 6.951-37.246-.812-7.76-7.764-7.51-21.806-.809-37.244a22.382 22.382 0 000-17.85c-6.705-15.437-6.954-29.48.81-37.243 7.766-7.76 21.808-7.51 37.245-.805a22.38 22.38 0 0017.85 0c15.437-6.706 29.478-6.954 37.238.809 7.763 7.763 7.518 21.806.813 37.24z" />
            <path
              d="M81.743 96.973c-5.251 0-11.543-1.538-18.192-4.447a29.495 29.495 0 00-11.9-2.493c-4.118 0-8.12.838-11.9 2.489-6.648 2.909-12.94 4.447-18.195 4.447-4.795 0-8.46-1.242-10.89-3.69-5.106-5.148-4.82-16.371.751-29.294a30.389 30.389 0 000-23.974c-5.57-12.922-5.86-24.145-.75-29.293 2.43-2.444 6.09-3.687 10.885-3.687 5.255 0 11.547 1.538 18.2 4.447a29.49 29.49 0 0011.9 2.49c4.117 0 8.12-.839 11.9-2.494 6.648-2.908 12.94-4.447 18.195-4.447 4.79 0 8.451 1.24 10.882 3.687 5.11 5.148 4.824 16.371-.747 29.294a30.389 30.389 0 000 23.973c5.57 12.923 5.857 24.146.747 29.293-2.43 2.456-6.095 3.699-10.886 3.699z"
              stroke="#fff"
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
          </g>
          <defs>
            <filter
              id="prefix__filter3_clover"
              x={0}
              y={0}
              width={104}
              height={104}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M98.978 43.072a22.383 22.383 0 000 17.85c6.706 15.438 6.951 29.48-.812 37.244-7.76 7.763-21.801 7.514-37.239.812a22.38 22.38 0 00-17.849 0c-15.437 6.706-29.483 6.951-37.246-.812-7.76-7.764-7.51-21.806-.809-37.244a22.382 22.382 0 000-17.85c-6.705-15.437-6.954-29.48.81-37.243 7.766-7.76 21.808-7.51 37.245-.805a22.38 22.38 0 0017.85 0c15.437-6.706 29.478-6.954 37.238.809 7.763 7.763 7.518 21.806.813 37.24z"
            fill={color}
          />
          <path
            d="M81.744 96.973c-5.252 0-11.544-1.539-18.192-4.447a29.495 29.495 0 00-11.9-2.493c-4.118 0-8.12.838-11.9 2.489-6.65 2.909-12.941 4.447-18.196 4.447-4.794 0-8.459-1.243-10.89-3.69-5.106-5.148-4.82-16.371.751-29.294a30.389 30.389 0 000-23.974c-5.57-12.922-5.86-24.145-.75-29.293 2.43-2.444 6.09-3.687 10.885-3.687 5.255 0 11.547 1.538 18.2 4.447a29.491 29.491 0 0011.9 2.49c4.117 0 8.12-.839 11.9-2.494 6.648-2.908 12.94-4.447 18.195-4.447 4.79 0 8.451 1.24 10.882 3.687 5.11 5.148 4.824 16.371-.747 29.294a30.388 30.388 0 000 23.973c5.571 12.923 5.857 24.146.747 29.293-2.43 2.456-6.095 3.699-10.885 3.699z"
            fill="#fff"
            stroke={color}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconClover
